import { useMemo } from 'react'

import {
  type AnalysisPayload,
  deriveReportConfigOptions,
  type ReportConfigOptions,
  useAnalysisWizardStore,
} from '@/modules/analysis'
import { useCaseConfigStore } from '@/modules/projects/stores/caseConfig'

export const useWizardActions = () =>
  useAnalysisWizardStore((state) => state.actions)

export const useWizardInstructions = () =>
  useAnalysisWizardStore((state) => state.instructions)

export const useWizardSelectedSections = () =>
  useAnalysisWizardStore((state) => state.selectedSections)

export const useWizardSectionInstructions = () =>
  useAnalysisWizardStore((state) => state.sectionInstructions)

export const useReportConfigOptions = (): ReportConfigOptions | null => {
  const isLoaded = useCaseConfigStore((state) => state.isLoaded)
  const sections = useCaseConfigStore((state) => state.sections)
  const suggestedSections = useCaseConfigStore(
    (state) => state.suggestedSections,
  )

  return useMemo(
    () =>
      isLoaded
        ? deriveReportConfigOptions({ sections, suggestedSections })
        : null,
    [isLoaded, sections, suggestedSections],
  )
}

export const useReportShapePayload = (): AnalysisPayload => {
  const configOptions = useReportConfigOptions()
  const instructions = useWizardInstructions()
  const selectedSections = useWizardSelectedSections()
  const sectionInstructions = useWizardSectionInstructions()

  const payload: AnalysisPayload = {
    instructions,
    sections: selectedSections.filter(
      (key) => !configOptions?.pinnedSectionsKeys.includes(key),
    ),
  }

  const filledInstructions = Object.fromEntries(
    Object.entries(sectionInstructions).filter(
      ([, value]) => value.trim().length > 0,
    ),
  )
  if (Object.keys(filledInstructions).length > 0) {
    payload.section_instructions = filledInstructions
  }

  return payload
}
